import { Stack } from "@freightsimple/ui-core/ComponentLayout/Stack";
import { T } from "@freightsimple/ui-core/Typography/T";
import { isNotBlank } from "@freightsimple/shared/Helpers/isNotBlank";

interface LocationSummaryGroupProps {
  label: string;
  /**
   * One line each. Blank entries are dropped, so an address with no second
   * line doesn't leave a gap.
   */
  lines: Array<string | undefined>;
}

/**
 * A labelled block in a saved location's summary — a small bold heading over a
 * stack of quiet lines (the address, the contact, the special services…).
 * Shared by the address book's location card and the quoting form's.
 */
export function LocationsSummaryGroup({
  label,
  lines,
}: LocationSummaryGroupProps) {
  const present = lines.filter((line): line is string => isNotBlank(line));

  return (
    <Stack gap={0} align="start">
      <T size="xs" weight="bold">
        {label}
      </T>
      {present.map((line) => (
        <T key={line} size="xs" color="secondary">
          {line}
        </T>
      ))}
    </Stack>
  );
}
